export default "__VITE_ASSET__QWw_xmSo__"